// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"681f78693fd53c37c84a","303":"92fc2d69ccd87003d323","495":"a5d206df87b647e2867d"}[chunkId] + ".js";
};